import {
  showNotification,
  NotificationProps,
  cleanNotifications,
} from "@mantine/notifications";

export const errorNotification = ({
  id = "error-message",
  color = "red",
  message = "Something Went Wrong",
  autoClose = 3000,
  ...rest
}: NotificationProps) => {
  cleanNotifications();
  showNotification({
    id,
    color,
    message,
    autoClose,
    ...rest,
  });
};

export const successNotification = ({
  id = "success-message",
  color = "green",
  autoClose = 3000,
  ...rest
}: NotificationProps) => {
  cleanNotifications();
  showNotification({
    id,
    color,
    autoClose,
    ...rest,
  });
};
